<div #hero
    class="hero-story"
    [ngClass]="{'media-engine': heroData.mediaEngine, 'media-engine-placeholder': !meLoaded}"
    *ngIf="heroData">
    <div class="media" finderAriaHidden="safari" [ngClass]="{'media-engine': heroData.mediaEngine}">
        <finder-hero-media *ngIf="!heroData.mediaEngine"
            [picture]="heroData.media"
            class="picture fit"></finder-hero-media>
        <finder-media-gallery *ngIf="heroData.mediaEngine"
            [version]="mediaEngine.version"
            [theme]="mediaEngine.theme"
            [production]="mediaEngine.production"
            [config]="mediaEngine.config"
            [ngClass]="{'disabled-fullscreen': disabledFullscreen}"
            (mediaEngineIsReady)="mediaEngineIsReady($event)"
            class=theme-{{mediaEngine.theme}}>
        </finder-media-gallery>
        <div *ngIf="heroData.cta" class="cta">
            <div class="cta-container">
                <div class="cta-picture">
                    <finder-picture
                        *ngIf="heroData.cta.picture"
                        [picture]="heroData.cta.picture"
                    ></finder-picture>
                </div>
                <div class="cta-mobile" *ngIf="!heroData.cta?.hideVideoPlayCTA">
                    <finder-hero-cta-heading
                        *ngIf="mobile.heading"
                        [ctaData]="mobile.heading"
                        ctaClass="heading"
                    ></finder-hero-cta-heading>
                    <finder-hero-cta-action
                        *ngIf="mobile.action?.playCTA"
                        [ctaData]="mobile.action.playCTA"
                        ctaClass="cta-action cta-video enter-fullscreen"
                        (ctaClick)="playbackVideo($event, true)"
                    ></finder-hero-cta-action>
                    <finder-hero-cta-action
                        *ngIf="mobile.action?.detailCTA"
                        [ctaData]="mobile.action.detailCTA"
                        ctaClass="cta-action"
                    ></finder-hero-cta-action>
                    <finder-hero-cta-action
                        *ngFor="let action of mobile.action?.ctas"
                        [ctaData]="action"
                        ctaClass="cta-action"
                    ></finder-hero-cta-action>
                </div>
                <div class="cta-desktop" *ngIf="!heroData.cta?.hideVideoPlayCTA">
                    <finder-hero-cta-heading
                        *ngIf="desktop.heading"
                        [ctaData]="desktop.heading"
                        ctaClass="heading"
                    ></finder-hero-cta-heading>
                    <finder-hero-cta-action
                        *ngIf="desktop.action?.playCTA"
                        [ctaData]="desktop.action.playCTA"
                        ctaClass="cta-action cta-video enter-fullscreen"
                        (ctaClick)="playbackVideo($event)"
                    ></finder-hero-cta-action>
                    <finder-hero-cta-action
                        *ngIf="desktop.action?.detailCTA"
                        [ctaData]="desktop.action.detailCTA"
                        ctaClass="cta-action"
                    ></finder-hero-cta-action>
                    <finder-hero-cta-action
                        *ngFor="let action of desktop.action?.ctas"
                        [ctaData]="action"
                        ctaClass="cta-action"
                    ></finder-hero-cta-action>
                </div>
            </div>
        </div>
    </div>
</div>
